import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '../data/mockData';
import { useTheme } from '../context/ThemeContext';

const ServicesSection = () => {
  const { isDark } = useTheme();

  return (
    <section className={`py-20 ${isDark ? 'bg-neutral-950' : 'bg-neutral-100'}`}>
      <div className="max-w-6xl mx-auto px-4">
        <h2 className={`text-3xl md:text-4xl font-bold text-center mb-12 ${isDark ? 'text-white' : 'text-neutral-900'}`}>
          Our <span className="text-lime-500">Services</span>
        </h2>
        
        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <Link
              key={service.id}
              to={service.link}
              className="group relative h-72 overflow-hidden rounded-xl"
            >
              {/* Background Image */}
              <div 
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                style={{ backgroundImage: `url(${service.image})` }}
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
              
              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-lg font-bold text-lime-400 mb-2">
                  {service.title}
                </h3>
                <p className="text-neutral-300 mb-4 text-sm">
                  {service.subtitle}
                </p>
                <div className="inline-flex items-center gap-2 px-4 py-2 border border-lime-500 text-white text-sm font-medium rounded-lg group-hover:bg-lime-500 group-hover:text-black transition-all duration-300">
                  Learn More
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
